import { AutoCycleTrack } from "helpers/auto-cycle-track";
class AnnouncementBar extends window.HTMLElement {
  constructor() {
    super();
    this.rotator = null;
    this.marquees = [];
    this.onClick = this.onClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.onClick);
    const bar = this.querySelector("[data-announcement-bar]");
    const track = this.querySelector("[data-announcement-track]");
    if (!bar || !track) return;
    this.rotator = new AutoCycleTrack({
      bar,
      track,
      itemSelector: "[data-announcement-item]"
    });
    this.rotator.init();
    this.initMarquees();
  }
  disconnectedCallback() {
    var _a;
    this.removeEventListener("click", this.onClick);
    (_a = this.rotator) == null ? void 0 : _a.destroy();
    this.destroyMarquees();
  }
  initMarquees() {
    this.destroyMarquees();
    this.querySelectorAll("[data-announcement-marquee]").forEach((viewport) => {
      const track = viewport.querySelector("[data-announcement-marquee-track]");
      const copy = viewport.querySelector("[data-announcement-marquee-copy]");
      const clone = viewport.querySelector("[data-announcement-marquee-clone]");
      if (!track || !copy || !clone) return;
      const marquee = { animation: null, observer: null };
      const update = () => {
        var _a;
        (_a = marquee.animation) == null ? void 0 : _a.cancel();
        marquee.animation = null;
        clone.classList.add("hidden");
        clone.classList.remove("flex");
        track.classList.add("justify-center");
        track.classList.remove("justify-start");
        track.style.transform = "";
        const isMobile = window.matchMedia("(max-width: 1023px)").matches;
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const shouldScroll = isMobile && copy.scrollWidth > viewport.clientWidth;
        if (!shouldScroll || reducedMotion) return;
        clone.classList.remove("hidden");
        clone.classList.add("flex");
        track.classList.remove("justify-center");
        track.classList.add("justify-start");
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 32;
        const distance = copy.getBoundingClientRect().width + gap;
        const duration = Math.max(8e3, distance / 35 * 1e3);
        marquee.animation = track.animate(
          [
            { transform: "translate3d(0, 0, 0)" },
            { transform: `translate3d(-${distance}px, 0, 0)` }
          ],
          { duration, iterations: Infinity, easing: "linear" }
        );
      };
      marquee.observer = new ResizeObserver(update);
      marquee.observer.observe(viewport);
      marquee.observer.observe(copy);
      this.marquees.push(marquee);
      update();
    });
  }
  destroyMarquees() {
    this.marquees.forEach(({ animation, observer }) => {
      animation == null ? void 0 : animation.cancel();
      observer == null ? void 0 : observer.disconnect();
    });
    this.marquees = [];
  }
  onClick(event) {
    var _a;
    const direction = event.target.closest("[data-announcement-prev]") ? -1 : event.target.closest("[data-announcement-next]") ? 1 : 0;
    if (direction) {
      (_a = this.rotator) == null ? void 0 : _a.step(direction);
      return;
    }
    if (event.target.closest(".announcement-bar-wrapper--close")) {
      const wrapper = this.closest(".announcement-bar-wrapper");
      if (wrapper) wrapper.style.display = "none";
    }
  }
}
window.customElements.define("announcement-bar", AnnouncementBar);
